<template>
    <div class="container">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">Reporte Diario de Parámetros</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="6" sm="3">
                        <date-picker class="dtpicker" v-model="fecha" @change="cargarDatos" range-separator="|" range format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="6" sm="3">
                        <v-btn @click="download" outlined color="green">Excel</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card>
            <v-card-title>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Busqueda"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table 
                :headers="cabeceras"
                :items="lista"
                :search="search"
                :items-per-page="30"
                class="elevation-2"
            >
                <template v-slot:item.alarma01="{ item }">
                    <v-chip
                        color="orange"
                        dark
                    >
                        {{ item.alarma01 }}
                    </v-chip>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue'
import Modal from '@/components/shared/Modal.vue'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
// import axios from 'axios'
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        fecha: new Date().toISOString().substr(0, 10),
        mostrar_fecha: false,
        lista:[],
        url_excel: '',
        search: '',
        show_excel: false,
        //configuracion para datatable
        cabeceras:[
            {   text: 'Punto de medición',  align: 'center',    sortable: true,     value: 'nombre_punto',      class: "cabecera",      filterable: true },
            {   text: 'Equipo',             align: 'center',    sortable: true,     value: 'nombre_equipo',     class: "cabecera",      filterable: true },
            {   text: 'Parametro',          align: 'center',    sortable: true,     value: 'nombre_parametro',  class: "cabecera",      filterable: true },
            {   text: 'Fecha',              align: 'center',    sortable: true,     value: 'fecha',             class: "cabecera",      filterable: true },
            {   text: 'Muestras',           align: 'center',    sortable: true,     value: 'cant',              class: "cabecera", },
            {   text: 'Alarma',             align: 'center',    sortable: true,     value: 'alarma01',          class: "cabecera", },
            {   text: 'Promedio',           align: 'center',    sortable: true,     value: 'media',             class: "cabecera", },
            {   text: 'Mínimo',             align: 'center',    sortable: true,     value: 'min_valor',         class: "cabecera", },
            {   text: 'Máximo',             align: 'center',    sortable: true,     value: 'max_valor',         class: "cabecera", },
        ],
        acciones:[
            {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.cargarDatos()
    },
    methods: {
        abrirAyudas() {
            const jiji = [
                {   titulo:`Ayuda de Reporte Diario de Parámetros`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra un listado de los promedios de cada parámetro medido de cada equipo y punto de medición correspondiente en el rango de fechas indicado.`},
                {   tipo:`label`,   texto:`- En el cuadro de búsqueda, se especifica el rango de fechas en el que se quieren obtener los datos. Esto cargará una tabla detallando el Punto de Medición, Equipo, Parámetro, Fecha, Muestras, Alarma, Promedio, valor Mínimo y valor Máximo de cada medición.`},
                {   tipo:`label`,   texto:`- Al pulsar el botón "Excel", se exportará toda la información mostrada según la fecha indicada en formato Excel.`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarDatos(){
            this.url_excel = '';
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})
            let fecha1 = this.fecha[0] ? this.fecha[0] : 0
            let fecha2 = this.fecha[1] ? this.fecha[1] : 0
            let url = `${this.base_url}resultados/reporte_parametros/${fecha1}/${fecha2}`;

            await this.axios.get(url,this.headers).then((response)=>{
                let resp = response.data.data
                this.lista = resp.resultados;
                this.url_excel = resp.url_excel;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.errorMessage(error, "Error al cargar información ");
            })
        },
        download(){
            window.location.href = this.url_excel;
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers']),
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table,
        DatePicker,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
    .mx-datepicker{
        width: 100% !important;
    }
</style>